export const PRICING_TABLES = "pricing-tables" as const
export const PRICING_TABLE = "pricing-table" as const


// WEBPACK FOOTER //
// ./src/utils/pricing/constants.ts